import http from '@/services/http.js';

export const fetchClientCompanies = async () => {
  const response = await http.get('/videoapi/infoUpload/getUserRoles/3');
  return response;
};

export const fetchMonthlyBills = async (params) => {
  const response = await http.get('/videoapi/bills/monthly', { params });
  return response;
};

function extractFileNameFromHeader(contentDisposition) {
  if (!contentDisposition) return null;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);

  if (utf8Match) return decodeURIComponent(utf8Match[1]);
  const fnMatch = contentDisposition.match(/filename=["']?([^"';]+)["']?/i);
  if (fnMatch) return fnMatch[1];
  return null;
}

export const exportBillExcel = async (filters) => {
  try {
    const response = await http.post(`/videoapi/infoUpload/exportBill`, filters, {
      responseType: 'blob',
    });

    if (response.data.type === 'application/json') {
      const text = await response.data.text();
      const errData = JSON.parse(text);
      return {
        success: false,
        unauthorized: errData.code === 401 || errData.unauthorized,
        message: errData.error || errData.message || '导出失败',
      };
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;

    const contentDisposition = response.headers['content-disposition'];
    a.download = extractFileNameFromHeader(contentDisposition) || '月账单.xlsx';

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error('导出账单失败:', error);
    return {
      success: false,
      unauthorized: error?.response?.status === 401,
      message: error?.response?.data?.message || error.message || '导出失败，请稍后重试',
    };
  }
};
